import { render, staticRenderFns } from "./trading-flow.vue?vue&type=template&id=9031e77c&scoped=true&"
import script from "./trading-flow.vue?vue&type=script&lang=js&"
export * from "./trading-flow.vue?vue&type=script&lang=js&"
import style0 from "./trading-flow.vue?vue&type=style&index=0&id=9031e77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9031e77c",
  null
  
)

export default component.exports